/* eslint-disable import/no-unresolved */
import React, { createContext } from "react";
import { shape } from "prop-types";

/**
 * Context para proveer multipleSignaturesData "scoped" cuando se renderizan
 * cards combinadas (transacciones de distintos tipos en firma/eliminación múltiple).
 * Los DataTables usan este valor cuando existe, en lugar del state de Redux.
 */
export const MultipleSignaturesDataContext = createContext(null);

export const MultipleSignaturesDataProvider = MultipleSignaturesDataContext.Provider;

/**
 * HOC que permite a los DataTables usar el Context cuando se renderizan
 * en vista combinada (una card por transacción con su formato correcto).
 */
export function withMultipleSignaturesContext(WrappedComponent) {
    function WithMultipleSignaturesContext(props) {
        const { multipleSignaturesData: propsMultipleSignaturesData } = props;
        const contextData = React.useContext(MultipleSignaturesDataContext);
        const multipleSignaturesData = contextData ?? propsMultipleSignaturesData;
        return <WrappedComponent {...props} multipleSignaturesData={multipleSignaturesData} />;
    }
    WithMultipleSignaturesContext.propTypes = {
        multipleSignaturesData: shape({}),
    };
    WithMultipleSignaturesContext.defaultProps = {
        multipleSignaturesData: null,
    };
    WithMultipleSignaturesContext.displayName = `WithMultipleSignaturesContext(${WrappedComponent.displayName ||
        WrappedComponent.name ||
        "Component"})`;
    return WithMultipleSignaturesContext;
}
